import SidePanel from '@monofront/design-system/organisms/SidePanel';
import { useTranslations } from 'next-intl';
import Divider from '@monofront/design-system/components/Divider';
import Link from 'next/link';
import { RoutesEnum } from '@monofront/types';
import useLocalizedRoutes from '@hooks/i18n/useLocalizedRoutes';

interface IGuaranteesSidePanel {
  isOpen: boolean;
  onClose: () => void;
  dataTestId?: string;
}

const GuaranteesSidePanel: React.FC<IGuaranteesSidePanel> = ({
  isOpen,
  onClose,
  dataTestId,
}) => {
  const tCheckout = useTranslations('Checkout');
  const { getPath } = useLocalizedRoutes();

  return (
    <SidePanel.SidePanel isOpen={isOpen} onClose={onClose}>
      <SidePanel.SidePanelHeader onClose={() => onClose()}>
        <h1
          className="tw-lf-title-xs desktop:tw-lf-title-sm"
          data-testid={dataTestId}
        >
          {tCheckout('membershipPlanSidePanelTitle')}
        </h1>
      </SidePanel.SidePanelHeader>
      <SidePanel.SidePanelBody>
        <h2 className="tw-lf-title-xs tw-mb-4 desktop:tw-lf-title-sm">
          {tCheckout('membershipPlanSidePanelSubtitle1')}
        </h2>
        <p className="tw-lf-body-regular-md">
          {tCheckout('membershipPlanSidePanelText1')}
        </p>
        <Divider marginVertical="tw-my-8" />
        <h2 className="tw-lf-title-xs tw-mb-4 desktop:tw-lf-title-sm">
          {tCheckout('membershipPlanSidePanelSubtitle2')}
        </h2>
        <p className="tw-lf-body-regular-md">
          {tCheckout('membershipPlanSidePanelText2')}
        </p>
        <Link
          href={getPath(RoutesEnum.CGV)}
          target="_blank"
          className="tw-lf-caption-regular tw-lf-link-dark tw-mt-4 tw-block tw-underline"
        >
          {tCheckout('membershipPlanSidePanelText2small')}
        </Link>
        <Divider marginVertical="tw-my-8" />
        <h2 className="tw-lf-title-xs tw-mb-4 desktop:tw-lf-title-sm">
          {tCheckout('membershipPlanSidePanelSubtitle3')}
        </h2>
        <p className="tw-lf-body-regular-md">
          {tCheckout('membershipPlanSidePanelText3')}
        </p>
        <ul className="tw-lf-bullet-list [&_li]:tw-lf-body-regular-md">
          <li className="tw-lf-bullet-list-item">
            {tCheckout('membershipPlanSidePanelText3ListItem1')}
          </li>
          <li className="tw-lf-bullet-list-item">
            {tCheckout('membershipPlanSidePanelText3ListItem2')}
          </li>
          <li className="tw-lf-bullet-list-item">
            {tCheckout('membershipPlanSidePanelText3ListItem3')}
          </li>
        </ul>
      </SidePanel.SidePanelBody>
      <SidePanel.SidePanelFooter>
        <button
          className="tw-lf-button tw-lf-button-primary tw-lf-button-md tw-w-full"
          onClick={onClose}
        >
          {tCheckout('membershipPlanSidePanelButtonLabel')}
        </button>
      </SidePanel.SidePanelFooter>
    </SidePanel.SidePanel>
  );
};

export default GuaranteesSidePanel;
